/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ivory_Lean_Rat_LiftInputs */

const en_ivory_lean_rat_lift = /** @type {(inputs: Ivory_Lean_Rat_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user has access to the following reports.`)
};

const de_ivory_lean_rat_lift = /** @type {(inputs: Ivory_Lean_Rat_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer hat Zugriff auf die folgenden Berichte.`)
};

/**
* | output |
* | --- |
* | "The user has access to the following reports." |
*
* @param {Ivory_Lean_Rat_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ivory_lean_rat_lift = /** @type {((inputs?: Ivory_Lean_Rat_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ivory_Lean_Rat_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ivory_lean_rat_lift(inputs)
	return de_ivory_lean_rat_lift(inputs)
});